import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	loginFormHeading: {
		id: 'true.med.login.title',
		defaultMessage: 'Save up to 40% off Calm Premium by using your HSA/FSA funds!',
		description: 'The title for the Calm login component',
	},
	valuePropHeader: {
		id: 'true.med.valueproplist.header',
		defaultMessage: 'Get a year of Calm Premium with your qualifying HSA/FSA funds',
		description: 'Value props header of calm with HSA/FSA funds',
	},
	valuePropSubHeader: {
		id: 'true.med.valueproplist.subHeader',
		defaultMessage: "You'll save up to 40% on your purchase!",
		description: 'Value props subheader of calm with HSA/FSA funds',
	},
	valueProp1Head: {
		id: 'true.med.valueprop1.header',
		defaultMessage: 'Checkout with your preferred payment method',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp1Body: {
		id: 'true.med.valueprop1.body',
		defaultMessage: 'Standard credit/debit, Apple Pay, GPay, or Paypal',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp2Head: {
		id: 'true.med.valueprop2.header',
		defaultMessage:
			'After you complete your purchase, you will receive a link to an eligibility survey from TrueMed',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp2Body: {
		id: 'true.med.valueprop2.body',
		defaultMessage:
			'You can find the link on your purchase confirmation page on our website, as well as your emailed receipt',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp3Head: {
		id: 'true.med.valueprop3.header',
		defaultMessage: 'Take the 1 minute survey to determine your eligibility',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp4Head: {
		id: 'true.med.valueprop4.header',
		defaultMessage:
			'In a few business days, the TrueMed Concierge will contact you about eligibility and provide instructions for receiving reimbursement from your HSA/FSA administrator',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	terms: {
		id: 'true.med.payment.terms.short2',
		defaultMessage:
			'This yearly membership gives you unlimited access to Calm’s entire library of content. You will be charged {price} for a 1 year subscription that will renew at {originalPrice}, billed annually.',
		description: 'A line to inform the user of the terms of their trial',
	},
	offerTerms: {
		id: 'purchaseTerms.noTrialTermsEligibility2',
		defaultMessage:
			'By clicking "Get Calm Premium", you agree to be automatically billed for Calm Premium at {price} for a 1 year subscription that will renew at {originalPrice}, billed annually. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for if user is not eligible for trial',
	},
	handoffCTALabel: {
		id: 'true.med.handoff.CTA.label',
		defaultMessage: 'Go to the Calm Web App',
		description: 'The button label of CTA',
	},
});

export const FaqMessages = defineMessages({
	faq1Question: {
		id: 'true.med.account.faq.q1',
		defaultMessage: 'How do I qualify to use my HSA/FSA funds through Truemed?',
		description: 'FAQ question about how HSA/FSA funds are qualified through Truemed',
	},
	faq1Answer: {
		id: 'true.med.account.faq.a1',
		defaultMessage:
			'After completing your purchase of Calm Premium, you will receive a link to a 1-minute survey from TrueMed to determine your reimbursement eligibility. This brief health intake survey will ask if you are working to treat, mitigate, or prevent a chronic health condition. After you complete the survey, your answers will be reviewed by a licensed medical provider and you will be emailed a Letter of Medical Necessity (LMN) if you qualify. TrueMed will also email you instructions on how to request reimbursement from your HSA/FSA administrator. Your HSA/FSA administrator will then decide whether you qualify for reimbursement',
		description: 'FAQ response about how HSA/FSA funds are qualified through Truemed',
	},
	faq2Question: {
		id: 'true.med.account.faq.q2',
		defaultMessage: 'What is an HSA/FSA account?',
		description: 'FAQ question about what is an HSA/FSA account',
	},
	faq2Answer: {
		id: 'true.med.account.faq.a2.new',
		defaultMessage:
			'Health Savings Accounts (HSA) and Flexible Spending Accounts (FSA) are tax-free accounts that can be used to pay for qualified health expenses (up to certain limits established by the IRS). These accounts are usually set up and managed by an HSA or FSA administrator, and you may have access to these accounts through your employer. HSAs are typically associated with a high-deductible health plan, and funds do not expire. FSAs are independent of your health plan, and funds elections occur in October-November each year for the following calendar year. FSA funds expire every calendar year. To learn more, please send an email to <supportTrueMedLink></supportTrueMedLink>.',
		description: 'FAQ response on what is an HSA/FSA account',
	},
	faq3Question: {
		id: 'true.med.account.faq.q3',
		defaultMessage: 'What is TrueMed?',
		description: 'FAQ question about what is TrueMed',
	},
	faq3Answer: {
		id: 'true.med.account.faq.a3.new',
		defaultMessage:
			'Truemed partners with health and wellness brands to enable qualified customers to use pre-tax HSA/FSA funds on health and wellness purchases. Truemed partners with a network of medical practitioners who can issue Letters of Medical Necessity to qualifying customers, thereby allowing customers to spend pre-tax HSA/FSA funds on medically-necessary health and wellness products. For more information, please send an email to <supportTrueMedLink></supportTrueMedLink>.',
		description: 'FAQ response on what is TrueMed',
	},
	faq4Question: {
		id: 'true.med.account.faq.q4',
		defaultMessage:
			'I do not have enough funds in my HSA/FSA account to cover my purchase in full, can I still qualify?',
		description: 'FAQ question about case where there are not enough funds in the HSA/FSA account',
	},
	faq4Answer: {
		id: 'true.med.account.faq.a4',
		defaultMessage:
			'Yes. You can submit a reimbursement request to your HSA/FSA plan administrator for up to the amount you have available in your HSA/FSA account.',
		description: 'FAQ response on case where there are not enough funds in the HSA/FSA account',
	},
	faq5Question: {
		id: 'true.med.account.faq.q5',
		defaultMessage: 'How can spending with HSA/FSA help me save up to 40%?',
		description: 'FAQ question about 40% discount',
	},
	faq5Answer: {
		id: 'true.med.account.faq.a5',
		defaultMessage:
			"HSA/FSA accounts consist of pre-tax funds, meaning you won't pay income tax on money you put into those accounts (up to certain limits established by the IRS) and use to pay for qualified medical expenses. Savings amount depends on your federal and state income tax brackets, which is determined by your annual taxable income.",
		description: 'FAQ response on 40% discount',
	},
	faq6Question: {
		id: 'true.med.account.faq.q6',
		defaultMessage: 'Can I use HSA/FSA to pay for other Calm products beyond annual memberships?',
		description: 'FAQ question about whether HSA/FSA can be used for other Calm products',
	},
	faq6Answer: {
		id: 'true.med.account.faq.a6',
		defaultMessage:
			'No, only the Calm Premium annual plan is eligible for reimbursement via HSA/FSA funds. Monthly or lifetime plans, gift cards, and other products are not eligible.',
		description: 'FAQ response on whether HSA/FSA can be used for other Calm products',
	},
	faq7Question: {
		id: 'true.med.account.faq.q7',
		defaultMessage: 'Can I use HSA/FSA funds to pay for a past Calm Premium purchase?',
		description: 'FAQ question about whether HSA/FSA can be used for paying a past Calm purshase',
	},
	faq7Answer: {
		id: 'true.med.account.faq.a7',
		defaultMessage:
			"No. You can't apply your HSA/FSA funds to a past Calm Premium purchase. Please contact your HSA or FSA administrator directly to learn more about your eligibility for reimbursement.",
		description: 'FAQ response on whether HSA/FSA can be used for paying a past Calm purshase',
	},
	faq8Question: {
		id: 'true.med.account.faq.q8',
		defaultMessage:
			'Can I also get a Letter of Medical Necessity from my doctor or other healthcare provider?',
		description:
			'FAQ question about whether a Letter of Medical Necessity can be provided by other healthcare provider',
	},
	faq8Answer: {
		id: 'true.med.account.faq.a8',
		defaultMessage:
			'Yes. A medical practitioner can issue a Letter of Medical Necessity to a patient who meets the requirements to qualify to use HSA/FSA funds on health and wellness purchases, as set forth by the Internal Revenue Service.',
		description:
			'FAQ response on whether a Letter of Medical Necessity can be provided by other healthcare provider',
	},
});

export default messages;
